import { IOrder } from 'order/entities';
import { pdfInstance } from 'store';

export class PdfApi {
  public static generateInvoice = (order: IOrder) => {
    return pdfInstance.post(`/generate/order-invoice.pdf`, order);
  };
}
